module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "opera-device"
  }, [_c('topNav', {
    attrs: {
      "title": _vm.$t('device_title'),
      "url": "/opera/setting"
    }
  }), _vm._v(" "), _c('mt-cell', {
    attrs: {
      "title": _vm.$t('device_name'),
      "value": _vm.os.name
    }
  }), _vm._v(" "), _c('mt-cell', {
    attrs: {
      "title": _vm.$t('device_language'),
      "value": _vm.os.language
    }
  }), _vm._v(" "), _c('mt-cell', {
    attrs: {
      "title": _vm.$t('device_version'),
      "value": _vm.os.version
    }
  }), _vm._v(" "), _c('mt-cell', {
    attrs: {
      "title": _vm.$t('device_vendor'),
      "value": _vm.os.vendor
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "empty"
  }), _vm._v(" "), _c('mt-cell', {
    attrs: {
      "title": "设备型号",
      "title": _vm.$t('device_model'),
      "value": _vm.device.model
    }
  }), _vm._v(" "), _c('mt-cell', {
    attrs: {
      "title": _vm.$t('device_vendor2'),
      "value": _vm.device.vendor
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "mint-cell"
  }, [_c('div', {
    staticClass: "mint-cell-left"
  }), _vm._v(" "), _c('div', {
    staticClass: "mint-cell-wrapper"
  }, [_c('div', {
    staticClass: "mint-cell-title"
  }, [_c('span', {
    staticClass: "mint-cell-text"
  }, [_vm._v(_vm._s(_vm.$t('device_uuid')))])]), _vm._v(" "), _c('div', {
    staticClass: "mint-cell-value"
  }, [_c('span', {
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._v(_vm._s(_vm.device.uuid))])])]), _vm._v(" "), _c('div', {
    staticClass: "mint-cell-right"
  })]), _vm._v(" "), _c('div', {
    staticClass: "empty"
  }), _vm._v(" "), _c('mt-cell', {
    attrs: {
      "title": _vm.$t('device_network'),
      "value": _vm.network
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "empty"
  }), _vm._v(" "), _c('mt-cell', {
    attrs: {
      "title": _vm.$t('device_screen'),
      "value": _vm.screen.resolutionWidth + '*' + _vm.screen.resolutionHeight
    }
  }), _vm._v(" "), _c('mt-cell', {
    attrs: {
      "title": "显示比例",
      "title": _vm.$t('device_scale'),
      "value": _vm.screen.scale
    }
  }), _vm._v(" "), _c('mt-cell', {
    attrs: {
      "title": "dpiX",
      "value": _vm.screen.dpiX
    }
  }), _vm._v(" "), _c('mt-cell', {
    attrs: {
      "title": "dpiY",
      "value": _vm.screen.dpiY
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-72571390","hasScoped":true}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/operaPage/device.vue
// module id = 1806
// module chunks = 107